const messages = {
    pageTitle: 'Składniki kalkulacji',
    menuTitle: 'Składniki kalkulacji',

    notifications: {
        nettoMarkUpUpdated: 'Narzut netto został zaktualizowany.',
        productGroupFactorUpdated: 'Współczynnik grupy produktowej został zaktualizowany.',
        tradersMarkUpUpdated: 'Narzut handlowca został zaktualizowany.'
    },

    errors: {
        fetchNettoMarkUps: 'Pobranie narzutów netto nie powiodło się.',
        fetchProductGroupFactors: 'Pobranie współczynników grupy produktowej nie powiodło się.',
        fetchTradersMarkUps: 'Pobranie narzutu handlowca nie powiodło się.',
        updateNettoMarkUp: 'Edycja narzutu netto nie powiodła się.',
        updateProductGroupFactor: 'Edycja współczynnika grupy produktowej nie powiodła się.',
        updateTradersMarkUp: 'Edycja narzutu handlowca nie powiodła się.'
    },

    selectMenu: {
        sentryLabels: {
            goToNettoMarkUp: 'Przekieruj na listę z narzutami netto',
            goToProductGroupFactors: 'Przekieruj na listę ze współczynnikami grupy produktowej',
            goToTradersMarkUp: 'Przekieruj na listę z minimalnym narzutem handlowca'
        },
        items: {
            nettoMarkUp: 'Narzut netto',
            productGroupFactors: 'Współczynnik grupy produktowej',
            tradersMarkUp: 'Minimalny narzut handlowca'
        }
    },

    common: {
        tooltips: {
            edit: 'Edytuj'
        },
        table: {
            headers: {
                name: 'Nazwa',
                type: 'Typ',
                valuePercent: 'Narzut %',
                actions: 'Akcje'
            }
        }
    },

    pages: {
        nettoMarkUp: {
            pageTitle: 'Narzut netto',
            table: {
                headers: {
                    name: 'Nazwa',
                    type: 'Typ',
                    valuePercent: 'Narzut %',
                    actions: 'Akcje'
                }
            },
            dialog: {
                title: 'Edycja narzutu: {name}',
                fields: {
                    value: 'Wartość'
                },
                validation: {
                    valueRequired: 'Proszę podać wartość procentową narzutu.',
                    valueInteger: 'Proszę podać liczbę całkowitą.'
                }
            }
        },
        productGroupFactors: {
            pageTitle: 'Współczynnik grupy produktowej',
            filters: {
                search: 'Szukaj...'
            },
            table: {
                headers: {
                    productTypeGroup: 'Produkt',
                    name: 'Nazwa',
                    type: 'Typ',
                    valuePercent: 'Narzut %',
                    actions: 'Akcje'
                }
            },
            dialog: {
                title: 'Edycja współczynnika grupy produktowej - {details}',
                fields: {
                    value: 'Wartość narzutu'
                },
                validation: {
                    valueRequired: 'Proszę podać wartość współczynnika.',
                    valueInteger: 'Proszę podać liczbę całkowitą.'
                }
            }
        },
        tradersMarkUp: {
            pageTitle: 'Narzut handlowca',
            table: {
                headers: {
                    name: 'Nazwa',
                    valuePercent: 'Narzut %',
                    actions: 'Akcje'
                }
            },
            dialog: {
                title: 'Edycja narzutu handlowca',
                fields: {
                    value: 'Wartość narzutu'
                },
                validation: {
                    valueRequired: 'Proszę podać wartość procentową narzutu.',
                    valueInteger: 'Proszę podać liczbę całkowitą.'
                }
            }
        }
    }
}

export default {
    messages,
    locale: 'pl'
}
